import { cn } from "@/lib/helpers/cn";
import { CheckboxGroup2 } from "@/ui2/molecules/CheckboxGroup";
import type { CheckboxGroup2Props } from "@/ui2/molecules/CheckboxGroup";

import { QuestionIndex } from "./QuestionIndex";

type FieldsetMultiChoiceProps = {
  questionNumber?: string;
} & CheckboxGroup2Props;

export function FieldsetMultiChoice({
  className,
  questionNumber,
  ...checkboxGroupProps
}: FieldsetMultiChoiceProps) {
  return (
    <>
      <QuestionIndex questionNumber={questionNumber} />
      <CheckboxGroup2
        className={cn("tw:flex tw:flex-col tw:gap-2", className)}
        {...checkboxGroupProps}
      />
    </>
  );
}
